import { render, staticRenderFns } from "./BankWithdrawal.vue?vue&type=template&id=402e3d88&scoped=true&"
import script from "./BankWithdrawal.vue?vue&type=script&lang=js&"
export * from "./BankWithdrawal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402e3d88",
  null
  
)

export default component.exports